import { Theme } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { getRGBA } from 'utils/color'

const sideBarSize = '5rem'
const sideBarSizeExpanded = '16rem'

const useStyles = makeStyles((theme: Theme) => ({
  subRoot: {
    position: 'fixed',
    top: 0,
    left: sideBarSizeExpanded,
    zIndex: 999,
    overflow: 'visible',
    width: sideBarSizeExpanded,
    height: '100vh',
    backgroundColor: '#FFFFFF',
    transition: 'width 80ms ease-in',
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
  },

  subHeader: {
    padding: '1rem 0rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  item: {
    fontFamily: 'Nunito ',
    fontSize: '0.875rem',
    fontWeight: '400 ',
    lineHeight: '1.25rem',
    padding: 0,
    margin: 0,
    color: '#0F0F1E',

    '& .MuiTreeItem-label': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-start',
      color: '#0F0F1E',
      fontSize: '0.875rem',
      fontWeight: '400',
      lineHeight: '1.25rem',
      userSelect: 'none',
      cursor: 'pointer',
      padding: 0,
      margin: 0,
      width: `calc(${sideBarSizeExpanded} - 3rem)`,
    },

    '& .MuiTreeItem-content': {
      color: theme.palette.primary.contrastText,
      padding: '0.75rem',
      margin: 0,
      transition: 'all 300ms ease',
      borderRadius: '0.5rem',

      '&:hover': {
        backgroundColor: `${getRGBA('#0F0F1E', 0.08)} !important`,
      },
    },

    '& .MuiTreeItem-content.Mui-selected': {
      backgroundColor: `${getRGBA('#0F0F1E', 0.08)} !important`,
    },

    '& .MuiIcon-root': {
      marginTop: '0.125rem',
      color: theme.palette.primary.contrastText,
      fontSize: '1.625rem',
      userSelect: 'none',
      cursor: 'pointer',
    },

    '& .MuiTreeItem-iconContainer': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      opacity: '0.5 !important',
      marginLeft: '0.25rem !important',
      width: 0,
    },

    '& .MuiSvgIcon-root': {
      color: theme.palette.primary.contrastText,
      fontSize: '1.625rem',
      userSelect: 'none',
      cursor: 'pointer',
    },

    '& .MuiCollapse-wrapper': {
      '& .MuiTreeItem-root': {
        margin: '0 !important',
      },
      '& .MuiCollapse-wrapper': {
        '& > .MuiTreeItem-root': {
          margin: '3rem !important',
        },

        '& > .MuiCollapse-wrapper': {
          '& > .MuiTreeItem-root': {
            margin: '6rem !important',
          },

          '& > .MuiCollapse-wrapper': {
            '& > .MuiTreeItem-root': {
              margin: '9rem !important',
            },
          },
        },
      },
    },
  },
}))

export { useStyles }
